import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'self-blocked-modal',
	template: require('./self-blocked-modal.component.html'),
})
export class SelfBlockedModalComponent {
	constructor(private activeModal: NgbActiveModal) {}

	public closeModal(): void {
		this.activeModal.close();
	}
}
